import { createWebHashHistory, createRouter } from 'vue-router'
/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/dashboard/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/register'),
    hidden: true
  },
  {
    path: '/offline',
    component: () => import('@/views/offline'),
    hidden: true,
    meta: { title: '离线页面' }
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/company/message',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'message_info',
        component: () => import('@/views/message/info/index.vue'),
        name: 'MessageInfo',
        meta: { title: '消息管理', icon: 'message' }
      }
    ]
  },
  {
    path: '/order/info',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'add',
        component: () => import('@/views/factory/cutting/order/add/index.vue'),
        name: 'OrderInfoAdd',
        meta: { title: '新建订单', activeMenu: '/factory/cutting_dev/cutting_price' }
      }
    ]
  },
  {
    path: '/factory/cutting/order',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'add',
        component: () => import('@/views/factory/cutting/order/add/index.vue'),
        name: 'FactoryCuttingOrderAdd',
        meta: { title: '新建订单', activeMenu: '/factory/cutting_dev/cutting_price' }
      }
    ]
  },
  {
    path: '/factory/plate_stock',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'stock_add/add',
        component: () => import('@/views/factory/plate_stock/add/add.vue'),
        name: 'PlateStockInAdd',
        meta: { title: '新增钢板入库', activeMenu: '/factory/plate_stock/stock_add' }
      },
      {
        path: 'stock_add_record',
        component: () => import('@/views/factory/plate_stock/add_record/index.vue'),
        name: 'PlateStockAddRecord',
        meta: { title: '入库记录', activeMenu: '/factory/plate_stock/stock_list' }
      },
      {
        path: 'delivery',
        component: () => import('@/views/factory/plate_stock/delivery/index.vue'),
        name: 'PlateStockDeliveryInfo',
        meta: { title: '送货单', activeMenu: '/factory/plate_stock/stock_list' }
      },
      {
        path: 'delivery/add',
        component: () => import('@/views/factory/plate_stock/delivery/add.vue'),
        name: 'PlateStockDeliveryAdd',
        meta: { title: '新增送货单', activeMenu: '/factory/plate_stock/stock_list' }
      }
    ]
  },
  {
    path: '/factory/factory_project',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'factory_contract/check',
        component: () => import('@/views/factory/project/contract/check.vue'),
        name: 'FactoryContractMaterialCheck',
        meta: { title: '合同材料核对', activeMenu: '/factory/factory_project/factory_contract' }
      },
      {
        path: 'factory_contract/repay',
        component: () => import('@/views/factory/project/contract/repay.vue'),
        name: 'FactoryContractArrivalRepay',
        meta: { title: '到货付款申请', activeMenu: '/factory/factory_project/factory_contract' }
      },
      {
        path: 'factory_contract/statistics',
        component: () => import('@/views/factory/project/contract/statistics.vue'),
        name: 'FactoryContractStatistics',
        meta: { title: '结算详情', activeMenu: '/factory/factory_project/factory_contract' }
      },
      {
        path: 'factory_account/check',
        component: () => import('@/views/factory/project/account/check.vue'),
        name: 'FactoryAccountMaterialCheck',
        meta: { title: '合同材料核对', activeMenu: '/factory/factory_project/factory_account' }
      },
      {
        path: 'factory_account/repay',
        component: () => import('@/views/factory/project/account/repay.vue'),
        name: 'FactoryAccountArrivalRepay',
        meta: { title: '入库付款申请', activeMenu: '/factory/factory_project/factory_account' }
      },
      {
        path: 'factory_account/final',
        component: () => import('@/views/factory/project/account/final.vue'),
        name: 'FactoryAccountOutboundFinal',
        meta: { title: '出库付款申请', activeMenu: '/factory/factory_project/factory_account' }
      },
      {
        path: 'factory_account/sale',
        component: () => import('@/views/factory/project/account/sale.vue'),
        name: 'FactoryAccountSale',
        meta: { title: '钢材买卖申请', activeMenu: '/factory/factory_project/factory_account' }
      },
      {
        path: 'factory_account/preprocessing',
        component: () => import('@/views/factory/project/account/preprocessing.vue'),
        name: 'FactoryAccountPreprocessing',
        meta: { title: '预处理申请', activeMenu: '/factory/factory_project/factory_account' }
      },
      {
        path: 'factory_account/statistics',
        component: () => import('@/views/factory/project/account/statistics.vue'),
        name: 'FactoryAccountStatistics',
        meta: { title: '结算详情', activeMenu: '/factory/factory_project/factory_account' }
      },
      {
        path: 'factory_account/status',
        component: () => import('@/views/factory/project/account/status.vue'),
        name: 'FactoryAccountStatus',
        meta: { title: '合同钢板状态', activeMenu: '/factory/factory_project/factory_account' }
      }
    ]
  },
  {
    path: '/factory/material_plan',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'plate_procurement/add',
        component: () => import('@/views/factory/purchase_plan/steel_plate/add.vue'),
        name: 'SteelPlatePurchaseAdd',
        meta: { title: '新增采购计划', activeMenu: '/factory/material_plan/plate_procurement' }
      },
      {
        path: 'plate_procurement/check',
        component: () => import('@/views/factory/purchase_plan/steel_plate/check.vue'),
        name: 'SteelPlateStockCheck',
        meta: { title: '入库核对', activeMenu: '/factory/material_plan/plate_procurement' }
      }
    ]
  },
  {
    path: '/factory/job_order',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'qianxin/add',
        component: () => import('@/views/factory/job_order/qianxin/add.vue'),
        name: 'JobOrderQianxinAdd',
        meta: { title: '加工任务单', activeMenu: '/factory/job_order/qianxin' }
      }
    ]
  },
  {
    path: '/factory/product_outbound',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'outbound/add',
        component: () => import('@/views/factory/product_outbound/outbound/add.vue'),
        name: 'ProductOutboundAdd',
        meta: { title: '产品出库', activeMenu: '/factory/product_outbound/outbound' }
      }
    ]
  },
  {
    path: '/cost/estimate',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'detail/:id(\\d+)',
        component: () => import('@/views/company/project/estimate/add/detail.vue'),
        name: 'CostEstimateDetail',
        meta: { title: '成本预算', activeMenu: '/company/project/cost_estimate' }
      },
      {
        path: 'detail',
        component: () => import('@/views/company/project/estimate/add/detail.vue'),
        name: 'CostEstimateAdd',
        meta: { title: '成本预算', activeMenu: '/company/project/cost_estimate' }
      }
    ]
  },
  {
    path: '/project/worker',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'add',
        component: () => import('@/views/company/worker_machine/worker/add/add.vue'),
        name: 'WorkerAdd',
        meta: { title: '工人信息', activeMenu: '/company/worker_machine/worker' }
      }
    ]
  },
  {
    path: '/project/machine',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'add',
        component: () => import('@/views/company/worker_machine/machine/add/add.vue'),
        name: 'MachineAdd',
        meta: { title: '机械信息', activeMenu: '/company/worker_machine/machine' }
      }
    ]
  },
  {
    path: '/company/client',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'client_person',
        component: () => import('@/views/company/client_supplier/client/person/index.vue'),
        name: 'ClientPerson',
        meta: { title: '客户联系人', activeMenu: '/company/client/client_info' }
      },
      {
        path: 'supplier_person',
        component: () => import('@/views/company/client_supplier/supplier/person/index.vue'),
        name: 'SupplierPerson',
        meta: { title: '供应商联系人', activeMenu: '/company/client/supplier_info' }
      }
    ]
  },
  {
    path: '/company/project',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'contract_add',
        component: () => import('@/views/company/project/contract/add/index.vue'),
        name: 'ContractAdd',
        meta: { title: '新建合同', activeMenu: '/company/project/contract_info' }
      },
      {
        path: 'contract_add/:id',
        component: () => import('@/views/company/project/contract/add/index.vue'),
        name: 'ContractDetail',
        meta: { title: '合同详情', activeMenu: '/company/project/contract_info' }
      },
      {
        path: 'contract_draft',
        component: () => import('@/views/company/project/contract/draft/index.vue'),
        name: 'ContractDraft',
        meta: { title: '参数化合同模板', activeMenu: '/company/project/contract_info' }
      },
      {
        path: 'contract_template',
        component: () => import('@/views/company/project/template/index.vue'),
        name: 'ContractTemplate',
        meta: { title: '参数化合同模板', activeMenu: '/company/project/contract_info' }
      },
      {
        path: 'contract_payment',
        component: () => import('@/views/company/project/contract/payment/index.vue'),
        name: 'ContractPayment',
        meta: { title: '合同收款', activeMenu: '/company/project/contract_info' }
      }
    ]
  },
  {
    path: '/company/reimbursement',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'reimbursement_add',
        component: () => import('@/views/company/payment/client/add/add.vue'),
        name: 'ReimbursementAdd',
        meta: { title: '报销单', activeMenu: '/company/reimbursement/my_reimbursement' }
      },
      {
        path: 'reimbursement_customer_add',
        redirect: (to) => ({
          path: '/company/payment/client_payment_add',
          query: to.query,
        }),
      },
      {
        path: 'reimbursement_mine',
        redirect: '/company/reimbursement/my_reimbursement'
      }
    ]
  },
  {
    path: '/company/payment',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'client_payment_add',
        component: () => import('@/views/company/payment/client/add/add.vue'),
        name: 'ClientPaymentAdd',
        meta: { title: '客户结算单据', activeMenu: '/company/payment/client_payment' }
      }
    ]
  },
  // 兼容旧路径跳转
  {
    path: '/contract',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'contract_add/:id',
        redirect: (to) => ({
          path: `/company/project/contract_add/${to.params.id}`,
          query: to.query,
        }),
      },
      {
        path: 'payment',
        redirect: (to) => ({
          path: '/company/project/contract_payment',
          query: to.query,
        }),
      },
    ],
  },
  // 兜底 404 路由，必须放在最后
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404'),
    hidden: true
  }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: '/system/user-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:user:edit'],
    children: [
      {
        path: 'role/:userId(\\d+)',
        component: () => import('@/views/system/user/authRole'),
        name: 'AuthRole',
        meta: { title: '分配角色', activeMenu: '/system/user' }
      }
    ]
  },
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:edit'],
    children: [
      {
        path: 'user/:roleId(\\d+)',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户', activeMenu: '/system/role' }
      }
    ]
  },
  {
    path: '/system/dict-data',
    component: Layout,
    hidden: true,
    permissions: ['system:dict:list'],
    children: [
      {
        path: 'index/:dictId(\\d+)',
        component: () => import('@/views/system/dict/data'),
        name: 'Data',
        meta: { title: '字典数据', activeMenu: '/system/dict' }
      }
    ]
  },
  {
    path: '/monitor/job-log',
    component: Layout,
    hidden: true,
    permissions: ['monitor:job:list'],
    children: [
      {
        path: 'index/:jobId(\\d+)',
        component: () => import('@/views/monitor/job/log'),
        name: 'JobLog',
        meta: { title: '调度日志', activeMenu: '/monitor/job' }
      }
    ]
  },
  {
    path: '/tool/gen-edit',
    component: Layout,
    hidden: true,
    permissions: ['tool:gen:edit'],
    children: [
      {
        path: 'index/:tableId(\\d+)',
        component: () => import('@/views/tool/gen/editTable'),
        name: 'GenEdit',
        meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});

export default router;
